<template>
  <div class="flex flex-col mb-4 w-full justify-between bg-beige-academy-200 pt-1 leading-7">
    <div class="mt-1 w-full border-b-2 border-grey-academy-150 px-3
      flex items-center justify-between py-1">
      <div class="flex flex-col md:flex-row items-start md:items-center">
        <span class="uppercase text-base md:text-lg mr-6 font-bold">{{ school.school_name }}</span>
        {{ school.city}}, {{school.country}}
      </div>
      <div v-if="!editing && isLogged" class="flex">
        <button class="hover:text-orange-academy-300" @click="editing = true">
          <edit-icon class="w-3 md:w-4" />
        </button>
        <button class="ml-3 hover:text-orange-academy-300" @click="deleteSchool">
          <bin-icon class="w-1" />
        </button>
      </div>
      <button class="w-auto bg-orange-academy-300 text-white rounded border
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 text-sm
        px-2 lg:px-4 py-0 lg:py-1"
        @click="updateSchool" v-if="editing">
          {{$t('stripe.save')}}
      </button>
    </div>
    <div v-if="!editing" class="flex flex-col w-full">
      <span class="w-full px-3 pt-3" v-if="school.pivot.course_title">
        {{$t('skills.course')}}: {{ school.pivot.course_title }}
      </span>
      <span class="w-full px-3 pt-3">
        {{$t('skills.year')}}: {{ school.pivot.year }}
      </span>
      <span class="w-full px-3 pt-3 pb-2">
        {{$t('skills.qualifications')}}: {{ school.pivot.qualification }}
      </span>
    </div>
    <div v-else class="px-3">
      <div class="flex justify-between items-center mt-3">
        <label for="course" class="w-1/3">{{$t('skills.course-attended')}}:</label>
          <input type="text" id="course" v-model="editedData.course_title"
          class="border-b-2 w-full p-2 border-grey-academy-150">
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="years" class="w-1/3">{{$t('skills.attended-year')}}:</label>
          <input type="text" id="years" v-model="editedData.year"
          class="border-b-2 w-full p-2 border-grey-academy-150"
          @keyup="resetErrorField('year')">
          <span class="text-red-500"
            v-if="errors.has('year')"
            v-text="errors.get('year')"
          >
          </span>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="qualification" class="w-1/3">{{$t('skills.title')}}:</label>
        <input type="text" id="qualification" v-model="editedData.qualification"
          class="border-b-2 w-full p-2 border-grey-academy-150">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Errors from '@/util/Errors';
import { mapGetters } from 'vuex';
import BinIcon from './graphics/BinIcon.vue';
import EditIcon from './graphics/EditIcon.vue';

export default {
  components: { EditIcon, BinIcon },
  props: ['school'],

  data() {
    return {
      editing: false,

      editedData: {
        course_title: this.school.pivot.course_title,
        year: this.school.pivot.year,
        qualification: this.school.pivot.qualification,
      },
      errors: new Errors(),
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    isLogged() {
      if (this.user && this.user.student.id === this.school.pivot.student_id) {
        return true;
      }
      return false;
    },
  },

  methods: {
    resetErrorField(field) {
      this.errors.clear(field);
    },
    updateSchool() {
      axios.put(`/api/students/${this.school.pivot.student_id}/schools/${this.school.id}`, this.editedData).then(() => {
        this.$emit('updated');
        this.editing = false;
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    deleteSchool() {
      axios.delete(`/api/students/${this.school.pivot.student_id}/schools/${this.school.id}`).then(() => {
        this.$emit('updated');
        this.editing = false;
      });
    },
  },

};
</script>
